import { useFlag } from '@calendly/feature-check-react'

import { useProductRefreshPreviewContext } from './productRefreshPreviewContext'

export const UI_THEME_FLAG_KEY = 'ap_rebrand_ui_theme'

export const useProductRefreshUiTheme = () => {
  const { override } = useProductRefreshPreviewContext()
  const rebrandUiThemeFlag = useFlag(UI_THEME_FLAG_KEY, false)

  return override === true && rebrandUiThemeFlag
}
